import React from 'react'
import moment from 'moment'
import { component_tool } from '@/tool'
const { WizTooltip } = component_tool

let componentName = 'siteOrderStatistic'

const renderInfo = (value) => {
  return (
    <WizTooltip
      title={
        <>
          <div>{'预约人： ' + (value.fullName || '')}</div>
          <div>{'联系电话： ' + (value.orderMobile || '')}</div>
          <div>{'预约时间： ' + (value.start + ' ~ ' + value.end)}</div>
        </>
      }
    >
      <div >{'预约人：' + (value.fullName || '')}</div>
    </WizTooltip>
  )
}

const renderDay = (value, row, index) => {
  const obj = {
    children: undefined,
    props: {},
  }
  if (value) {
    obj.props.colSpan = value.colSpan
    if (value.colSpan) {
      if (value.own) {
        obj.props.style = { backgroundColor: '#F50C0C', color: 'white' }
      } else {
        obj.props.style = { backgroundColor: '#1AAAFF', color: 'white' }
      }
      obj.children = renderInfo(value)
    }
  }
  return obj
}

const monthColumns = (start, end, self) => {
  let monthColumns = []
  let year = start.getFullYear()
  let month = start.getMonth() + 1
  let children = []

  let map = {
    columns: []
  }
  let index = 1
  let exportChildren = []
  let defaultExportProps = {
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    }
  }

  while (start.getTime() <= end.getTime()) {
    let title = year + '-' + (month <= 9 ? '0' + month : month)
    if (start.getFullYear() !== year || start.getMonth() + 1 !== month) {
      monthColumns.push({
        title,
        tableItem: {
          children
        }
      })

      map.columns.push({
        headerName: title,
        children: exportChildren
      })

      year = start.getFullYear()
      month = start.getMonth() + 1
      let day = '01'
      let key = year + '-' + (month <= 9 ? '0' + month : month) + '-' + day
      children = [{
        title: day,
        dataIndex: ['map', key],
        key,
        render: (value, row, index) => renderDay(value, row, index)
      }]

      exportChildren = [{
        headerName: day,
        field: key,
        width: 10,
        ...defaultExportProps
      }]

      map[key] = index
    } else {
      let day = start.getDate()
      day = day <= 9 ? '0' + day : '' + day
      let key = title + '-' + day
      children.push({
        title: day,
        dataIndex: ['map', key],
        key,
        render: (value, row, index) => renderDay(value, row, index)
      })

      exportChildren.push({
        headerName: day,
        field: key,
        width: 10,
        ...defaultExportProps
      })

      map[key] = index
    }
    start = start.setDate(start.getDate() + 1)
    start = new Date(start)
    index++
  }

  let title = year + '-' + (month <= 9 ? '0' + month : month)
  monthColumns.push({
    title,
    tableItem: {
      children
    }
  })

  map.columns.push({
    headerName: title,
    children: exportChildren
  })

  self._map = map
  return monthColumns
}

const columns = (self) => {
  let columns = [
    {
      title: '日期范围',
      name: 'time',
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD',
        rules: [{ required: true, message: '请选择日期范围' }]
      }
    },
    {
      title: '场地名称',
      name: 'name',
      searchItem: {}
    },
    {
      title: '场地编号',
      name: 'code',
      searchItem: {}
    }
  ]
  let { start, end } = self.state
  if (start && end) {
    columns = columns.concat([
      {
        title: '场地名称',
        name: 'name',
        tableItem: {}
      },
      {
        title: '场地编号',
        name: 'code',
        tableItem: {}
      },
      {
        title: '城市',
        name: 'city',
        tableItem: {}
      }
    ])
    columns = columns.concat(monthColumns(start, end, self))
  }
  return columns
}

const templateConfig = (self) => {
  let buttonSort = []
  if (self.state.start && self.state.end) {
    buttonSort = ['export']
  }
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            let start = new Date(moment(value.time[0]).valueOf())
            let end = new Date(moment(value.time[1]).valueOf())
            value.start = moment(value.time[0]).format('YYYY-MM-DD')
            value.end = moment(value.time[1]).format('YYYY-MM-DD')
            self.setState({ start, end })
            // delete value.time
            return value
          },
          buttonSort,
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          bordered: true,
          loading: false
        },
        rowOperateSort: [],
        rowOperateView: []
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/appointmentArrangement`,
    payload: {
      key: `${componentName}@appointmentArrangement`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/exportAppointmentArrangement`,
    payload: {
      key: `${componentName}@exportAppointmentArrangement`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
